module.exports = __webpack_public_path__ + "static/media/logo.1d1c4095.png";